var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_c('span', {
    directives: [{
      name: "t",
      rawName: "v-t",
      value: _vm.footerLinks.label,
      expression: "footerLinks.label"
    }],
    staticClass: "h6 font-weight-bold"
  })]), _vm._v(" "), _vm._l(_vm.footerLinks.listLinks, function (l, subKey) {
    return _c('li', {
      key: subKey
    }, [_c('MdmLink', {
      attrs: {
        "url": l.url,
        "is-scramble-link": _vm.isScrambleLink,
        "target": l.openNewPage ? '_blank' : '_self'
      },
      domProps: {
        "innerHTML": _vm._s(l.label)
      }
    })], 1);
  })], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };